import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProductService } from 'src/_lib/service/product.service';
import { environment } from 'src/environments/environment.prod';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { MatButtonModule } from '@angular/material/button';
import { BrowserService } from 'src/_lib/service/browser.service';
import { NgFor, NgClass, NgIf } from '@angular/common';
import { ReviewItSubmitPopupComponent } from '../review-it-popup/review-it-submit-popup/review-it-submit-popup.component';
import { reviewsPostDataInterface } from 'src/_lib/interfaces/request-interfaces/review-It-popup.interface';

@Component({
  selector: 'app-love-it-popup',
  templateUrl: './love-it-popup.component.html',
  styleUrls: ['./love-it-popup.component.scss'],
  standalone: true,
  imports: [MatButtonModule, ReactiveFormsModule, NgxIntlTelInputModule, NgFor, NgClass, NgIf],
})
export class LoveItPopupComponent implements OnInit {
  isSubmitClicked: boolean = false;
  loveItForm: FormGroup;
  cdnImagePath: string = environment.cdnImagePath;
  baseUrl: string;
  stars = [1, 2, 3, 4, 5];
  selectedRating = 5;
  hoverRating = 5;

  constructor(
    private formBuilder: FormBuilder,
    private productHttp: ProductService,
    private browser: BrowserService,
    public dialogRef: MatDialogRef<LoveItPopupComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: { product_name: string, prod_description: string, prod_image: string, product_key:any },
  ) { }

  ngOnInit(): void {
    this.baseUrl = window.location.origin;
    this.loveItForm = this.formBuilder.group({
      first_name: ['', Validators.required],
      email_address: ['', [Validators.required, Validators.email]],
      comments: ['', Validators.required],
      product_key: this.data.product_key,
      appearance: [this.selectedRating, Validators.required],
      installation: [this.selectedRating, Validators.required],
      quality: [this.selectedRating, Validators.required],
      price_value:[this.selectedRating, Validators.required]
    });
  }

  closePopup(): void {
    this.dialogRef.close();
  }

  submit() {
    this.isSubmitClicked = true;
    this.loveItForm.patchValue({
      appearance: this.selectedRating,
      installation: this.selectedRating,
      quality: this.selectedRating,
      price_value:this.selectedRating
    });
    if (this.loveItForm.valid) {
      this.isSubmitClicked = false;
      const data: reviewsPostDataInterface = this.loveItForm.value;
      this.productHttp.reviewIt(data).subscribe(
        {
          next: (response) => {
            if (response[0].success === true) {
              this.closePopup();
              this.openReviewItPopUpSuccess();
              setTimeout(() => {
                this.loveItForm.reset();
              }, 2000);
            }
          },
          error: (error) => {
            this.isSubmitClicked = true;
          }
        }
      );
    } else {
      this.isSubmitClicked = true;
    }
  }

  share(platform: string) {
    const formattedProductName = this.data.product_name.replace(/\s+/g, '-').toLowerCase();
    const url = encodeURIComponent(`${this.baseUrl}/${formattedProductName}/p${this.data.product_key}`);
    let shareUrl = '';
    switch (platform) {
      case 'facebook':
        shareUrl = `http://www.facebook.com/sharer.php?u=${url}`;
        break;
      case 'twitter':
        shareUrl = `https://twitter.com/intent/tweet?url=${url}&text=${this.data.product_name}`;
        break;
      case 'linkedin':
        shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${this.data.product_name}`;
        break;
      case 'pinterest':
        shareUrl = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}` +`&media=${encodeURIComponent(this.cdnImagePath + this.data.prod_image)}`+ `&description=${encodeURIComponent(this.data.prod_description)}`;
        break;
    }
    this.browser.window?.open(shareUrl, '_blank', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=600,height=300');
  }

  openReviewItPopUpSuccess(): void {
    const dialogRef = this.dialog.open(ReviewItSubmitPopupComponent, {
      width: '250px',
      data: { message: 'You have successfully signed up to get the best deals.' },
    });
    dialogRef.afterClosed().subscribe(() => { });
  }

  onMouseMove(event: MouseEvent, star: number): void {
    const element = event.target as HTMLElement;
    const rect = element.getBoundingClientRect();
    const x = event.clientX - rect.left;
    if (x < rect.width / 2) {
      this.hoverRating = star - 0.5;
    } else {
      this.hoverRating = star;
    }
  }

  getStarClass(star: number): string {
    if (this.hoverRating >= star) {
      return 'fas fa-star star-color';
    }
    if (this.hoverRating >= star - 0.5) {
      return 'fas fa-star-half-alt star-color';
    }
    return 'far fa-star text-secondary';
  }
}